import React, { useEffect, useMemo, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ITEM_PER_PAGE, PUBLIC_URL, SEARCH_DELAY } from "../../app.config";
import Pagination from "../../component/Pagination";
import SearchAndExport from "../../component/SearchAndExport";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import useDebounce from "../hooks/useDebounce";
import * as API from "../../utils/api.service";
import { PermissionContext } from "../../context/PermissionContext";
import Cookies from "js-cookie";
import {
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleNoDataFound,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
} from "../../utils/common.service";
import { getBlogApiCall, editBlogApiCall } from "../../Store/slices/blogSlice";

export default function ManageBlog() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
  const [page, setPage] = useState(1);
  const [fieldSort, setFieldSort] = useState("id desc");
  const [ascSort, setAscSort] = useState(false);
  const [sortColumn, setSortColumn] = useState("id");
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  let userData = Cookies.get("dataCA")
    ? JSON.parse(Cookies.get("dataCA"))
    : null;
  const role = userData ? userData.role : null;
  const { permissions } = useContext(PermissionContext);

  const handleSortChange = (fieldName, sort) => {
    if (sort === "asc") {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(true);
    } else {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(false);
    }
  };

  const {
    blogList: { data: blogList },
  } = useSelector((state) => state.blog);
  console.log('blogList------------------- :', blogList);

  useEffect(() => {
    handleCompanyListAPI();
  }, [page, debounce, fieldSort]);

  const handleCompanyListAPI = () => {
    let submitData = {
      search: debounce,
      page: page,
      fieldSort,
    };
    // let request = {};
    dispatch(getBlogApiCall(submitData));
  };

  const handleStatusChange = async (id, currentStatus) => {
    console.log("currentStatus :", currentStatus);
    dispatch(setLoader(true));
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    let submitData = { id, status: newStatus };

    try {
      await dispatch(editBlogApiCall(submitData));
      dispatch(getBlogApiCall({
        search: debounce,
        page: page,
        fieldSort: fieldSort,
      }));

      SWIT_DELETE_SUCCESS(`Status changed to ${newStatus} successfully`);
    } catch (error) {
      console.error("Error changing status:", error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleDeleteManage = async (id) => {
    SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
      if (result?.isConfirmed) {
        dispatch(setLoader(true));
        let submitData = {
          id: id,
          status: "Deleted",
        };

        // console.log(
        //   "444444444444444444444444444444444444444444444444444444",
        //   submitData
        // );

        await dispatch(editBlogApiCall(submitData));
        await handleCompanyListAPI();
        await SWIT_DELETE_SUCCESS(`Blog delete successfully`);
      }
    });
  };

  const companyListData = useMemo(() => {
    return blogList?.map((item, index) => (
      <>
        <tr key={index}>
          <td>{index+1}</td>
          <td>{item?.ar_title}</td>
          <td>{item?.title}</td>
          <td>
            <img
              src={item?.blog_image}
              alt="blog Image"
              style={{ width: "50px", height: "50px", objectFit: "contain" }}
            />
          </td>
          {role == "admin" ||
          (permissions[10]?.module_id === 11 &&
            permissions[10]?.permission_update === 1) ? (
            <td>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`is_active_${item.id}`}
                  checked={item?.status === "Active"}
                  onChange={(e) => {
                    // console.log("e--------------------", e.target.value);
                    handleStatusChange(item?.id, item?.status);
                  }}
                />
              </div>
            </td>
          ) : (
            <td>{item?.status}</td>
          )}
          <td>

          {role == "admin" ||
            (permissions[10]?.module_id === 10 &&
              permissions[10]?.permission_view === 1) ? (
              <a
                className="text-reset fs-18 cursor_pointer"
                onClick={() =>
                  navigate(`/manage_blog/view_blog`, {
                    state: { blogData: item },
                  })
                }
              >
                {" "}
                <i className="ri-eye-line"></i>
              </a>
            ) : null}

            {role == "admin" ||
            (permissions[10]?.module_id === 11 &&
              permissions[10]?.permission_update === 1) ? (
                <a
                className="text-reset fs-18 m-1 cursor_pointer"
                onClick={() =>
                  navigate(`/manage_blog/edit_blog`, {
                    state: { blogData: item },
                  })
                }
              >
                {" "}
                <i className="ri-edit-line"></i>
              </a>
            ) : (
             null
            )}

            {role == "admin" ||
            (permissions[10]?.module_id === 11 &&
              permissions[10]?.permission_delete === 1) ? (
              <a
                className="text-reset fs-18 cursor_pointer"
                onClick={() => handleDeleteManage(item?.id)}
              >
                {" "}
                <i className="ri-delete-bin-6-line"></i>
              </a>
            ) : (
              null
            )}
          </td>
        </tr>
      </>
    ));
  }, [blogList]);

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Manage Blog`} header={`Blog`} />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="rounded-3 mb-3">
                <SearchAndExport
                  searchFieldName={`blog`}
                  setSearch={setSearch} isExport={false}
                  // handleExportApiCall={handleExportApiCall}
                  buttonName={`Add Blog`} navigatePath={`/manage_blog/add_blog`}
                />
              </div>
              <div className="responsive-table-plugin">
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive"
                    data-pattern="priority-columns"
                  >
                    {Object.keys(blogList)?.length > 0 ? (
                      <>
                        <table
                          id="tech-companies-1"
                          className="table table-centered mb-0 table-hover "
                        >
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                className={`cursor_pointer bi ${
                                  sortColumn === "id"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "id",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Id
                              </th>

                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "blog_title"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "blog_title",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Blog Arebic Title
                              </th>
                              <th>Blog English Title</th>
                              <th scope="col">Blog Image</th> 
                              <th
                                scope="col"
                                className={`cursor_pointer bi ${
                                  sortColumn === "status"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "status",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Status
                              </th>

                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{companyListData}</tbody>
                        </table>
                      </>
                    ) : (
                      <>{handleNoDataFound("blog")}</>
                    )}
                  </div>
                  <Pagination
                    per_page={ITEM_PER_PAGE}
                    pageCount={blogList[0]?.blog_count}
                    onPageChange={handlePageChange}
                    page={page}
                    lableName={`blog`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
